export const WORKSPACE_POLICY_PINE_PREVIEW_OPEN = "tessera:workspace-policy-pine-preview-open";
export const WORKSPACE_POLICY_PINE_PREVIEW_HIDE = "tessera:workspace-policy-pine-preview-hide";

export type WorkspacePolicyPinePreviewOpenDetail = {
  strategyId: string;
  policyVersionId: string;
  title: string;
  policyRowVersion?: string | null;
};

function trimId(value: string): string {
  return value.trim();
}

export function dispatchWorkspacePolicyPinePreviewOpen(
  detail: WorkspacePolicyPinePreviewOpenDetail
): void {
  if (typeof window === "undefined") return;
  const strategyId = trimId(detail.strategyId);
  const policyVersionId = trimId(detail.policyVersionId);
  if (!strategyId || !policyVersionId) return;
  window.dispatchEvent(
    new CustomEvent<WorkspacePolicyPinePreviewOpenDetail>(WORKSPACE_POLICY_PINE_PREVIEW_OPEN, {
      detail: {
        strategyId,
        policyVersionId,
        title: detail.title.trim() || "Policy Pinescript",
        policyRowVersion: detail.policyRowVersion ?? null,
      },
    })
  );
}

export function dispatchWorkspacePolicyPinePreviewHide(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(WORKSPACE_POLICY_PINE_PREVIEW_HIDE));
}
